export default "__VITE_ASSET__bad78850__"